import { createContext, useContext } from "react";

/**
 * The measured height of the fixed offline banner that DefaultLayout pins at
 * `top: 0`.
 *
 * DefaultLayout observes that wrapper with a ResizeObserver (it collapses to 0
 * when IsOfflineBar renders nothing) and offsets both the fixed header and the
 * content column by the result. Anything else that pins itself to the top of
 * the viewport has to take the same offset or the banner paints over it — so
 * the value is published here rather than re-measured, which would mean a
 * second observer racing the first.
 */
export const OfflineBarHeightContext = createContext(0);

export const useOfflineBarHeight = (): number => useContext(OfflineBarHeightContext);
